import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import Styles from './Grid.module.scss';

const Grid = ({ children, theme = {}, type }) => {
  const gridContainerClasses = [Styles.gridContainer, theme.gridContainer];
  if (type) gridContainerClasses.push(theme[type], Styles[type]);
  return (
    <div className={classNames(gridContainerClasses)}>
      {React.Children.map(children, child => (
        <div className={classNames(Styles.gridItem, theme.gridItem)}>{child}</div>
      ))}
    </div>
  );
};

Grid.defaultProps = {
  children: [],
};

Grid.propTypes = {
  children: PropTypes.arrayOf(PropTypes.element),
  theme: PropTypes.shape({}),
  type: PropTypes.string,
};

export default Grid;
